import service from './RestService';
import { RestResponse } from '../types/response/RestResponse';
import { Barrier, BarrierFormData, BarrierLog, BarrierLogType, BarrierModeData } from '../state/barriers/types';

const path = '/barriers';

class BarrierServis {
  getBarriers = (): RestResponse<Barrier[]> => service.get(`${path}`);

  createNewBarrier = (data: BarrierFormData): RestResponse<null> => service.post(`${path}`, data);

  editBarierDevice = (barrierId: number, data: BarrierFormData): RestResponse<null> => service.put(`${path}/${barrierId}`, data);

  enableMaintenanceMode = (barrierId: number, data: BarrierModeData) => service.post(`${path}/${barrierId}/service-mode`, data);

  deleteBarrierDevice = (barrierId: number): RestResponse<null> => service.delete(`${path}/${barrierId}`);

  getBarrier = (barrierId: number): RestResponse<Barrier> => service.get(`${path}/${barrierId}`);

  getBarrierLogs = (barrierId: number, startTime: string, endTime: string, typeFilter: BarrierLogType | string): RestResponse<BarrierLog[]> =>
    service.get(`${path}/${barrierId}/logs`, { startTime, endTime, typeFilter });
}
export default new BarrierServis();
